import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as userAPI from "./userAPI";

// Async thunk for fetching user info
export const fetchLoggedInUserInfoAsync = createAsyncThunk(
  "user/fetchLoggedInUserInfo",
  async (Email) => {
    try {
      const response = await userAPI.fetchLoggedInUserInfo(Email);
      console.log("Response from API:", response);
      return response;
    } catch (error) {
      console.error("Error fetching user:", error);
      throw error;
    }
  }
);

// Async thunk for fetching PDE info
export const fetchPDEInfoAsync = createAsyncThunk(
  "user/fetchPDEInfo",
  async (PDE_ID) => {
    try {
      //debugger;
      const response = await userAPI.fetchPDEInfo(PDE_ID);
      console.log("Response from PDE API:", response);
      return response;
    } catch (error) {
      console.error("Error fetching PDE:", error);
      throw error;
    }
  }
);

const initialState = {
  userInfo: null,
  user: [],
  evaluations: [],
  latestEvaluation: [],
  pdeReviewStatus: [],
  pdeInfo: null, // Include PDE info in the initial state
  status: "idle",
  error: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearUserData: (state) => {
      return initialState;
    },
    resetpdeInfo: (state) => {
      state.pdeInfo = state.initialState;
    },
    updatePDEInfo: (state, action) => {
      state.pdeInfo = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoggedInUserInfoAsync.pending, (state) => {
        state.status = "loading";
      })

      .addCase(fetchLoggedInUserInfoAsync.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.userInfo = action.payload.user;
        state.evaluations = action.payload.evaluations;
        state.pdeReviewStatus = action.payload.pdeReviewStatus || [];
        state.user = action.payload.user;

        // Extract the latest evaluation (the first one in the array)
        if (
          action.payload.evaluations &&
          action.payload.evaluations.length > 0
        ) {
          state.latestEvaluation = action.payload.evaluations[0];
        }
      })

      .addCase(fetchLoggedInUserInfoAsync.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchPDEInfoAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPDEInfoAsync.fulfilled, (state, action) => {
        console.log("pdeinfo =" + action.payload);
        state.status = "succeeded";
        //debugger;
        state.pdeInfo = action.payload;
        console.log(state.pdeInfo);
        //debugger;
        // window.location.reload();
      })
      .addCase(fetchPDEInfoAsync.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const selectUserInfo = (state) => state.user.userInfo;
export const selectUser = (state) => state.user.user;
export const selectUserEvaluations = (state) => state.user.evaluations;
export const selectPDEReviewStatus = (state) => state.user.pdeReviewStatus;

export const selectLatestEvaluation = (state) => state.user.latestEvaluation;
export const selectPDEInfo = (state) => state.user.pdeInfo; // Selector for PDE info
export const { clearUserData, resetpdeInfo, updatePDEInfo } = userSlice.actions;

export default userSlice.reducer;
